export const ROLE_COMPANY_ADMIN = 'company_admin'
export const ROLE_MANAGER = 'manager'
export const ROLE_READ_ONLY_USER = 'read_only_user'
export const ROLE_SUPER_COMPANY_ADMIN = 'super_company_admin'
